module.exports = __webpack_public_path__ + "fonts/b7c5127.eot";